(function () {
  "use strict";

  angular
    .module("admin.users.details.devices", [])
    .controller("DevicesAdminCtrl", DevicesAdminCtrl);

  /** @ngInject */
  function DevicesAdminCtrl($scope, $state, $stateParams, UsersService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.totalUsers = 0;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1,
    };

    vm.sortType = "";
    vm.sortReverse = false;

    vm.encrypt = function (value) {
      var result = "";
      for (var i = 0; i < value.length; i++) {
        if (i < value.length - 1) {
          result += value.charCodeAt(i) + 10;
          result += "-";
        } else {
          result += value.charCodeAt(i) + 10;
        }
      }
      return result;
    };

    load(1);

    var oldSortType;
    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }

      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }

      oldSortType = angular.copy(vm.sortType);
      UsersService.listDevices(
        $stateParams.parentId,
        vm.oldPage,
        25,
        vm.sortType
      ).then(success);

      function success(result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        for (var i = 0; i < result.results.length; i++) {
          result.results[i].ts = new Date(
            parseInt(
              result.results[i].ts
                .toString()
                .substring(0, result.results[i].ts.toString().length - 3)
            )
          );
        }
        vm.items = result.results;
        vm.sortType = oldSortType;
      }
    }

    vm.pageChanged = function (newPage) {
      vm.sortType = oldSortType;
      load(newPage);
    };

    vm.clearDevices = function () {
      swal(
        {
          title: "Clear devices",
          text: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: "slide-from-top",
        },
        function (isConfirm) {
          if (isConfirm) {
            UsersService.clearDevices(vm.userId).then(function () {
              load(vm.pagination.current);
            });
          }
        }
      );
    };

    vm.delete = function (id) {
      UsersService.deleteDevice(vm.userId, id).then(function () {
        load(vm.pagination.current);
      });
    };

    vm.sort = function (type) {
      vm.sortReverse = !vm.sortReverse;
      if (vm.sortReverse) {
        vm.sortType = type + "-asc";
      } else {
        vm.sortType = type + "-desc";
      }
      load(vm.pagination.current);
    };

    vm.reload = function (ip) {
      var ip = vm.encrypt(ip);
      $state.go("admin.users.details.ips", { id: vm.userId, ip: ip });
    };
  }
})();
